<template>
  <div class="details-block" :class="{ 'details-block--open': isOpen }">
    <div class="details-block__header" @click="toggleOpen">
      <slot name="header"></slot>
      <button type="button" class="details-block__button">
        <lucide-icon :name="isOpen ? 'chevron-up' : 'chevron-down'" />
      </button>
    </div>
    <transition name="details-block__transition">
      <div v-show="isOpen" class="details-block__content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import LucideIcon from "./LucideIcon.vue";

defineOptions({
  name: "DetailsBlock"
});

const props = defineProps({
  open: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits<{
  (e: "update:open", open: boolean): void;
}>();

const isOpen = ref(props.open);
watch(
  () => props.open,
  (open) => {
    isOpen.value = open;
  },
  { immediate: true }
);

function toggleOpen() {
  isOpen.value = !isOpen.value;
  emit("update:open", isOpen.value);
}
</script>

<style lang="scss">
.details-block {
  transition: all 0.3s ease-in-out;
}

.details-block__header {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.details-block__button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
}

.details-block__transition-enter-active,
.details-block__transition-leave-active {
  transition: all 150ms ease-out;
}

.details-block__transition-enter-from,
.details-block__transition-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}
</style>
